// Тултип: shadcn 4.21.1 (base-mira, Base UI), подогнан под ui-spec §5 (задача D5):
// - первый тултип — через 500 мс (`--tooltip-delay`, задержку держит Base UI: `TooltipProvider delay`), появляется за
//   125 мс от точки привязки (.tip из motion.css); следующий, пока прошлый не успел закрыться, — сразу и без перехода
//   (Base UI ставит `data-instant`, .tip[data-instant] — 0 мс);
// - тёмная плашка --foreground с текстом --background (контраст как у основного текста), 12/16;
// - анимации tw-animate-css и стрелка убраны: стрелка в плотном пульте только шумит.
import { Tooltip as TooltipPrimitive } from '@base-ui/react/tooltip';
import { cn } from 'cn';

/** Задержка первого тултипа, мс (ui-spec §5, `--tooltip-delay`). */
export const TOOLTIP_DELAY_MS = 500;

function TooltipProvider({ delay = TOOLTIP_DELAY_MS, ...props }: TooltipPrimitive.Provider.Props) {
  return <TooltipPrimitive.Provider data-slot="tooltip-provider" delay={delay} {...props} />;
}

function Tooltip({ ...props }: TooltipPrimitive.Root.Props) {
  return <TooltipPrimitive.Root data-slot="tooltip" {...props} />;
}

function TooltipTrigger({ ...props }: TooltipPrimitive.Trigger.Props) {
  return <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} />;
}

function TooltipContent({
  className,
  side = 'top',
  sideOffset = 6,
  align = 'center',
  alignOffset = 0,
  children,
  ...props
}: TooltipPrimitive.Popup.Props &
  Pick<TooltipPrimitive.Positioner.Props, 'align' | 'alignOffset' | 'side' | 'sideOffset'>) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Positioner
        align={align}
        alignOffset={alignOffset}
        side={side}
        sideOffset={sideOffset}
        className="isolate z-50"
      >
        <TooltipPrimitive.Popup
          data-slot="tooltip-content"
          className={cn(
            'tip z-50 w-fit max-w-72 rounded-md bg-foreground px-2 py-1 text-sm text-pretty text-background',
            className,
          )}
          {...props}
        >
          {children}
        </TooltipPrimitive.Popup>
      </TooltipPrimitive.Positioner>
    </TooltipPrimitive.Portal>
  );
}

export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger };
